











































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import ECharts from 'vue-echarts'
import Util from '../../../lib/util'
import circleChart from '../../../components/charts/circleCharts.vue'
import {GetWardList,GetShiftList} from '../../../api/specialDictionary'

@Component({
    components:{circleChart}
})
export default class extends Vue {
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:Object,default:{}}) data:any;
    options1:any = {}
    options2:any = {}
    async created(){
        this.options1 = {
            data:[
                {maxValue:5011,minValue:1100}
            ]
        }
        this.options2 = {
            data:[
                {maxValue:500,minValue:400},
                {maxValue:100,minValue:60},
            ]
        }


        await this.getWardList()
        await this.getShiftList()
    }
    wardList = []
    shiftList = []
    shiftActive:any = {}
    wardActiveIndex = 0
    wardActive:any = {}
    //获取病区
    async getWardList(){
        let data = {
            QueryString:'',
            SkipCount:1,
            MaxResultCount:10000
        }
        let res = await GetWardList(data)
        this.wardList = res.items
        this.wardActive = res.items[0]
    }
    //获取班次
    async getShiftList(){
        let data = {
            QueryString:'',
            SkipCount:1,
            MaxResultCount:10000
        }
        let res = await GetShiftList(data)
        this.shiftList = res.items
        this.shiftActive = res.items[0]
    }

    cancel(){
        (this.$refs.roleForm as any).resetFields();
        this.$emit('input',false);
    }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dialysisProcess/dialysisArea/statistics.vue